import React from "react";
import { FaCheck, FaCircleCheck } from "react-icons/fa6";
import { BTN_SIZE, Container, H2_SIZE, H3_SIZE } from "../home/ui";

// NOTE: confirm these prices with DataMetricks before going live (copied from the design mockup).
const plans = [
  {
    name: "Basic",
    text: "Essential maintenance for small websites.",
    price: "$49",
    features: ["Security updates", "Regular backups", "Uptime monitoring", "Email support"],
  },
  {
    name: "Standard",
    text: "Perfect for growing businesses.",
    price: "$99",
    features: ["Everything in Basic", "Performance optimization", "Bug fixes", "Priority support"],
    popular: true,
  },
  {
    name: "Premium",
    text: "Advanced support for high-traffic websites.",
    price: "$199",
    features: ["Everything in Standard", "Advanced security monitoring", "Dedicated support", "Custom development support"],
  },
];

const MaintPlans = () => (
  <section className="bg-gradient-to-b from-[#F7F9FE] to-white py-[48px] lg:py-[68px]">
    <Container className="max-w-[1200px]">
      <div className="text-center">
        <h2 className={`font-extrabold tracking-tight text-[#0B1A4A] ${H2_SIZE}`}>
          Flexible <span className="text-[#1E6BFF]">Maintenance Plans</span>
        </h2>
        <p className="mx-auto mt-[12px] max-w-[560px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
          Choose a plan that fits your business needs.
        </p>
      </div>

      <div className="m-swipe mt-[44px] grid items-center gap-[24px] md:grid-cols-3">
        {plans.map((p) => (
          <div
            key={p.name}
            className={`overflow-hidden rounded-[18px] bg-white ${
              p.popular
                ? "border-[1.5px] border-solid border-[#1E6BFF] shadow-[0_24px_50px_-26px_rgba(30,91,255,0.55)] md:-my-[20px]"
                : "shadow-[0_14px_36px_-24px_rgba(40,60,140,0.35)]"
            }`}
          >
            {p.popular && <p className="bg-[#1E6BFF] py-[6px] text-center text-[13px] font-semibold text-white">Most Popular</p>}
            <div className="p-[24px] sm:p-[28px]">
              <h3 className={`font-bold text-[#0B1A4A] ${H3_SIZE}`}>{p.name}</h3>
              <p className="mt-[6px] text-[14px] text-slate-500">{p.text}</p>
              <p className="mt-[18px] flex items-baseline gap-[6px]">
                <span className="text-[34px] font-extrabold text-[#0B1A4A]">{p.price}</span>
                <span className="text-[14px] text-slate-500">/ month</span>
              </p>
              <ul className="mt-[18px] space-y-[12px]">
                {p.features.map((f) => (
                  <li key={f} className="flex items-center gap-[12px] text-[14px] text-slate-600">
                    {p.popular ? (
                      <FaCircleCheck className="shrink-0 text-[16px] text-[#1E6BFF]" />
                    ) : (
                      <FaCheck className="shrink-0 text-[13px] text-[#14B8A6]" />
                    )}
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href="/contact-us"
                className={`mt-[28px] flex items-center justify-center rounded-full font-medium transition ${BTN_SIZE} ${
                  p.popular
                    ? "bg-[#1E5BFF] text-white shadow-[0_14px_30px_-14px_rgba(30,91,255,0.8)] hover:brightness-110"
                    : "border-[1.5px] border-solid border-[#7FA3FF] text-[#1E4DFF] hover:bg-[#EEF3FF]"
                }`}
              >
                Get Started
              </a>
            </div>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default MaintPlans;
